<template>
  <div class="incoming-info-actions">
    <div class="tooltip">
      <Button
        :loading="createLoading"
        size="small"
        type="borderless"
        left-icon="plus"
        :disabled="isAtLeastOneDraft"
        @click="handleCreation"
      >
        {{ $t('Create offer') }}
      </Button>
      <div v-if="isAtLeastOneDraft" class="tooltip-text tooltip-text_md">
        {{ $t('You can create only one draft offer. Please submit it before creating a new one.') }}
      </div>
    </div>
    <Button
      v-if="isIncomingTenderInfoPage($route) && isNotOffered"
      size="small"
      type="borderless"
      color="danger"
      left-icon="x"
      :loading="declineLoading"
      @click="handleDecline"
    >
      {{ $t('Decline participation') }}
    </Button>
    <div v-if="!isIncomingTenderInfoPage($route)" class="offers-filter spacex-8">
      <!--      TODO: размер-->
      <Switcher size="sm" :value="showOldAndArchivedOffers" @change="changeShowingOffers" />
      <div class="offers-filter__text text-sm grey-900">
        {{ $t('Show') }}
        <Badge color="orange">
          {{ tenderOfferVersionStatuses['old'] }}
        </Badge>
        {{ $t('and') }}
        <Badge color="light-red">
          {{ tenderOfferVersionStatuses['archived'] }}
        </Badge>
      </div>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import CreateOfferModal from '@/containers/incoming-tender/CreateOfferModal';
  import { isIncomingTenderInfoPage } from '@/utils/route-matcher';
  import Switcher from '@/components/ui/Switcher';
  import Badge from '@/components/ui/Badge';

  export default {
    name: 'OfferActions',
    components: { Button, Switcher, Badge },
    data() {
      return {
        declineLoading: false,
        createLoading: false,
      };
    },
    computed: {
      ...mapState('incomingTender', ['incomingTenderInfo', 'showOldAndArchivedOffers']),
      ...mapGetters('incomingTender', ['isAtLeastOneDraft']),
      ...mapState('global', ['tenderOfferVersionStatuses']),
      isNotOffered() {
        return this.incomingTenderInfo?.status !== 'offered';
      },
    },
    methods: {
      isIncomingTenderInfoPage,
      ...mapActions('incomingTender', ['declineOffer', 'createIncomingTenderVersion']),
      ...mapActions('modal', ['openModal']),
      ...mapMutations('incomingTender', ['changeIncomingTender']),
      changeShowingOffers() {
        this.changeIncomingTender({
          key: 'showOldAndArchivedOffers',
          value: !this.showOldAndArchivedOffers,
        });
      },
      async handleCreation() {
        this.openModal({
          component: CreateOfferModal,
          context: {
            status: this.incomingTenderInfo.status,
          },
        });
      },
      async handleDecline() {
        this.declineLoading = true;
        await this.declineOffer();
        this.declineLoading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .incoming-info-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 20px;

    height: 48px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px #e8ebf0;

    .offers-filter {
      display: flex;

      &__text {
        display: grid;
        align-content: center;
        grid-auto-flow: column;
        grid-column-gap: 4px;
      }
    }
  }
</style>
